module.exports = __webpack_public_path__ + "static/media/view1.57da5ceb.jpg";